export default theme => ({
  phoneDisplay: {
    fontSize: `${theme.textSizes[1]}px !important`,
    fontWeight: "normal !important",
  },
});
